import { createAction } from 'typesafe-actions';
import { WalletType } from './types';

/** @deprecated */
export const validateSignerEvent = createAction('VALIDATE_SIGNER_EVENT')<{
  event: string;
  walletType: WalletType | null;
  publicKey: string | null;
}>();

export const setActiveWalletAndKey = createAction('SET_ACTIVE_WALLET_AND_KEY')<{
  walletType: WalletType | null;
  publicKey: string | null;
}>();

export const setActiveWalletName = createAction('SET_ACTIVE_WALLET_NAME')<{
  walletName: string;
}>();

export const disconnectWallet = createAction('DISCONNECT_WALLET')<void>();
